import { VenueGroup } from 'apis/venue-groups/types';
import useIsEnterpriseUser from 'modules/enterprise/hooks/useIsEnterpriseUser';

import { useGetBrandsForUser } from '../../front-page/Search/hooks/useGetBrandsForUser';
import { useGetEnterprisesForUser } from '../../front-page/Search/hooks/useGetEnterprisesForUser';
import useGetMerchants from '../../front-page/Search/hooks/useGetMerchants';
import useGetVenues from '../../front-page/Search/hooks/useGetVenues';

export const useGetEntitiesForUser = () => {
  const { isEnterpriseUser, isLoading: isLoadingEnterpriseUser } = useIsEnterpriseUser();
  const { enterprises, isLoading: isLoadingEnterprises } = useGetEnterprisesForUser();
  const { brands, isLoading: isLoadingBrands } = useGetBrandsForUser();

  const { merchants, isLoading: isLoadingMerchants } = useGetMerchants();
  const isVenueFetchEnabled = !isLoadingEnterpriseUser && !isEnterpriseUser;
  const { venues, isLoading: isLoadingVenues } = useGetVenues(isVenueFetchEnabled);
  const venueGroups: VenueGroup[] = []; // todo @navjotahuja92 remove components and empty array

  return {
    entities: { merchants, venues, venueGroups, enterprises, brands },
    isLoading:
      isLoadingMerchants || (isVenueFetchEnabled && isLoadingVenues) || isLoadingEnterprises || isLoadingBrands,
  };
};
